import { render, staticRenderFns } from "./ComMenu.vue?vue&type=template&id=08b0587a&scoped=true"
import script from "./ComMenu.vue?vue&type=script&lang=js"
export * from "./ComMenu.vue?vue&type=script&lang=js"
import style0 from "./ComMenu.vue?vue&type=style&index=0&id=08b0587a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0587a",
  null
  
)

export default component.exports